import React from 'react';
import ErrorBoundary from './components/ErrorBoundary';
import MalaysiaClinicFinder from './components/MalaysiaClinicFinder';
import Header from './components/Header';
import Banner from './components/Banner';
import Container from './components/Container';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <Header />
        <Banner />
        <div id="search">
          <Container>
            {/* <h2 className="text-2xl font-bold mb-6 text-gray-800">Clinic Search</h2> */}
            <MalaysiaClinicFinder />
          </Container>
        </div>
        <Footer />
      </ErrorBoundary>
    </div>
  );
}

export default App;